import { ref } from 'vue'
import { post } from '../../../utils/index'
import { debounce } from 'lodash-es'
import { pgMessage } from '../../message/index'

export function useGetData(dataParameters, dataUrl) {
  const keyword = ref(null)
  const getData = (clearPageNo) => {
    tableRef.value.loadDataAsync(async (page) => {
      if (!dataUrl) {
        pgMessage.error('未配置【dataUrl】')
        return {}
      }
      if (clearPageNo) {
        page.pageNo = 1
      }
      const param = { ...dataParameters.value, ...page }
      param.parameters = { ...param.parameters, keyword: keyword.value }
      const [resData] = await post(dataUrl, param)
      if (resData && keyword.value === param.parameters.keyword) {
        return resData
      } else {
        return {}
      }
    })
  }
  const tableRef = ref(null)
  const opened = () => getData(true)
  const change = debounce(opened, 300)

  return {
    tableRef,
    keyword,
    opened,
    change,
    getData,
  }
}
